export const MASS_CONFIG_DEFAULTS = {
  sensitive: 0,
  videoBefore: 5,
  videoAfter: 10,
  eventDebounce: 30,
  media: "video",
  audioAlert: false,
};
